/**
 * Sanitiza el monto de préstamo: solo dígitos y un punto decimal (máx. 2 decimales).
 * Normaliza coma decimal (teclados mobile) a punto.
 * @param {string|number} valor - Valor crudo del input
 * @returns {string} Monto sanitizado
 */
export function sanitizarMontoPrestamo (valor) {
  let texto = String(valor || '').replace(/,/g, '.')
  texto = texto.replace(/[^\d.]/g, '')
  const primerPunto = texto.indexOf('.')
  if (primerPunto === -1) {
    return texto
  }
  const enteros = texto.slice(0, primerPunto)
  const decimales = texto.slice(primerPunto + 1).replace(/\./g, '').slice(0, 2)
  return `${enteros}.${decimales}`
}



// WEBPACK FOOTER //
// ./src/utils/prestamosVidaMontoUtil.js